var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},_vm._l((_vm.cards),function(key){return _c('v-col',{key:key},[_c('v-card',{staticClass:"p-3",attrs:{"outlined":""}},[_c('v-skeleton-loader',{staticClass:"mb-2",attrs:{"type":"avatar"}}),_c('v-skeleton-loader',{attrs:{"type":"text"}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }